import * as React from 'react';
import { Box, Stack, Typography, Drawer } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useNavigate } from "react-router-dom";
import * as JSTool from '../store/JSTool';
import MobileMenu from './MobileMenu';

export default function NavView(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();

    React.useEffect(() => {


    }, []);

    function musicTap() {
        dispatch(settingActions.setPlayingMusic());
    }

    function closeMenuTap() {
        dispatch(settingActions.setOpenMenu(false));
    }

    return (
        <Stack sx={{
            position: 'fixed',
            width: 1,
            minWidth: settingData.isMobile ? 1 : '750rem',
            height: '60rem',
            alignItems: 'center',
            zIndex: 100,
            flexDirection: 'row',
            backgroundImage: `url(${JSTool.getImgPath('menu-bg.webp')})`,
            backgroundSize: '100% 100%',
            color: 'black',
        }}>

            <Box component={'img'}
                src={JSTool.getImgPath('logo_black2.png')}
                sx={{
                    height: 0.5,
                    ml: settingData.isMobile ? 3 : 5,
                    filter: 'brightness(0)' //0黑 1白
                }} />
            <Box sx={{ flex: 1 }} />

            {/* PC */}
            <Stack sx={{
                display: settingData.isMobile ? 'none' : 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            }}>
                <NavItem index={0} title="Home" />
                <NavItem index={1} title="Class" />
                <NavItem index={2} title="The Continent of Magna" />
                <NavItem index={3} title="Features" />

                <Box
                    onClick={musicTap}
                    component={'img'}
                    src={settingData.playingMusic ? JSTool.getImgPath('menu-btn-music_play.png') : JSTool.getImgPath('menu-btn-music_stop.png')}
                    sx={{
                        height: '25rem',
                        mr: 2,
                        ml: 5,
                        animation: settingData.playingMusic ? 'musicRotate 3s linear infinite' : '',
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.1)',
                        }
                    }} />

                <Typography
                    onClick={() => {
                        dispatch(settingActions.showRegisterAlert(true));
                    }}
                    sx={{
                        fontSize: '12rem',
                        border: '1px solid black',
                        py: 0.4,
                        px: 2,
                        mr: 5,
                        borderRadius: '20rem',
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        fontFamily: window.font0,
                        '&:hover': {
                            transform: 'scale(1.05)',
                        }
                    }}>
                    Pre-register Now
                </Typography>
            </Stack>

            {/* Mobile */}
            <Stack
                sx={{
                    display: settingData.isMobile ? 'flex' : 'none',
                    flexDirection: 'row',
                    alignContent: 'center',
                    pr: 2,
                }}>
                <Box
                    onClick={() => {
                        if (JSTool.isIOS) {
                            JSTool.appleTap();
                        } else {
                            JSTool.googleTap();
                        }

                    }}
                    component={'img'}
                    src={JSTool.isIOS ? JSTool.getImgPath('down_apple.png') : JSTool.getImgPath('down_google.png')}
                    sx={{
                        width: '120rem',
                        display: 'none',
                    }} />

                <Box
                    onClick={() => {
                        dispatch(settingActions.setOpenMenu(true));
                    }}
                    component={'img'}
                    src={JSTool.getImgPath('menu_black.png')}
                    sx={{
                        width: '40rem',
                        ml: 2
                    }} />

            </Stack>

            <Drawer
                PaperProps={{
                    style: {
                        width: '100%',
                        height: '100%',
                        backgroundColor: '#00000066',
                        boxShadow: 'none',
                        padding: 0,
                        margin: 0,
                        justifyContent: 'center',
                        alignItems: 'center',
                        backdropFilter: 'blur(3px)',
                        WebkitBackdropFilter: 'blur(3px)',
                    },
                }}
                anchor={'right'}
                open={settingData.openMenu}
                onClose={closeMenuTap}>
                <MobileMenu />
            </Drawer>

        </Stack>

    );
}


function NavItem(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    function itemClick() {
        const index = props.index;
        dispatch(settingActions.setNavIndex(index));
        var instance = $('#home_page_sp')[0].swiper;
        instance.slideTo(index);
    }

    return (
        <Stack
            onClick={itemClick}
            sx={{
                mx: '15rem',
                zIndex: 2,
                position: 'relative',
            }}>

            <Typography sx={{
                cursor: 'pointer',
                textAlign: 'center',
                color: settingData.navIndex == props.index ? '#007aff' : 'black',
                fontSize: '14rem',
                transitionDuration: '0.3s',
                fontFamily: window.font0,
                pb: '3rem',
                pl: '20rem',
                '&:hover': {
                    transform: 'scale(1.1)',
                }
            }}>
                {props.title}
            </Typography>

            <Box
                component={'img'}
                src={JSTool.getImgPath('menu-item-hover.webp')}
                sx={{
                    display: 'none',
                    position: 'absolute',
                    height: '40rem',
                    top: '-10rem',
                }}
            />

        </Stack>
    );
}
